import { Injectable, makeStateKey, StateKey } from '@angular/core';
import { CampaignTypes } from '@shared/constants';
import { AnyChallengeDTO } from '@shared/dto';
import { Reward } from '@shared/factory';
import { CampaignsByPhase } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class ApiStateService {
  public CAMPAIGNS_KEY = {
    [CampaignTypes.LOYALTYCHALLENGE]: makeStateKey<CampaignsByPhase>(
      CampaignTypes.LOYALTYCHALLENGE
    ),
    [CampaignTypes.EVENT]: makeStateKey<CampaignsByPhase>(CampaignTypes.EVENT),
    [CampaignTypes.LOYALTYCHALLENGE_BIS]: makeStateKey<CampaignsByPhase>(
      CampaignTypes.LOYALTYCHALLENGE_BIS
    ),
    [CampaignTypes.PERSONALIZED_PROMOTIONS]: makeStateKey<CampaignsByPhase>(
      CampaignTypes.PERSONALIZED_PROMOTIONS
    ),
  };
  public CHALLENGES_KEY: {
    [campaignId: number]: StateKey<AnyChallengeDTO[]>;
  } = {};
  public RECENT_PLAYER_KEY = makeStateKey<boolean>('recentPlayer');
  public LAST_PURCHASE_KEY = makeStateKey<string>('lastPurchase');

  public TOTAL_REWARDS_KEY: {
    [campaignId: number]: StateKey<number>;
  } = {};

  // Burn Page
  public REWARDS_KEY = makeStateKey<Reward[]>('rewards');
  public PURCHASED_REWARDS_KEY = makeStateKey<Reward[]>('purchased-rewards');
}
